import { emptyState } from "../components/states";
import { el } from "../lib/dom";
import { homePath } from "../router/paths";
import type { PageView } from "../router/router";

export function notFoundPage(): PageView {
  return {
    element: el("section", {
      className: "page page--not-found",
      children: [
        emptyState("Page not found", "That address doesn't match anything in this app."),
        el("a", { className: "button button--secondary", attrs: { href: homePath() }, text: "Back to notes" }),
      ],
    }),
  };
}
